module.exports = __webpack_public_path__ + "static/img_9669-a0ae60fee5abb3c827a39f8c1ba744ae.webp";